import { render, staticRenderFns } from "./addAcademic.vue?vue&type=template&id=f5736c80&scoped=true&"
import script from "./addAcademic.vue?vue&type=script&lang=js&"
export * from "./addAcademic.vue?vue&type=script&lang=js&"
import style0 from "./addAcademic.vue?vue&type=style&index=0&id=f5736c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5736c80",
  null
  
)

export default component.exports